import api from '@api'
import {
  transformAssetMovement,
  transformAsset,
  transformAssetMovementForServer,
} from '@data/asset-movement'
import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import {
  buildRelationalQualificationStructure,
  buildFlatQualificationStructure,
  transformBatchQualForServer,
} from '@data/qualification'
const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

const getQualifications = (filters) => {
  const qualDetails = []
  if ('ids' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'id',
        'in',
        filters.ids,
        'long',
        'db'
      )
    )
  }
  if ('excludedIds' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'id',
        'not_in',
        filters.excludedIds,
        'long',
        'db'
      )
    )
  }
  if ('assetCondition' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'assetCondition',
        'in',
        filters.assetCondition,
        'enum',
        'db'
      )
    )
  }
  if ('assetConditionExcluded' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'assetCondition',
        'not_in',
        filters.assetConditionExcluded,
        'enum',
        'db'
      )
    )
  }
  if ('fromLocation' in filters && filters.fromLocation.length > 0) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'locationId',
        'in',
        filters.fromLocation,
        'listLong',
        'db'
      )
    )
  }
  if ('fromDepartment' in filters && filters.fromDepartment.length > 0) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'assignedDepartmentId',
        'in',
        filters.fromDepartment,
        'listLong',
        'db'
      )
    )
  }
  if ('movementStatus' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'movementStatus',
        'in',
        filters.movementStatus,
        'enum',
        'db'
      )
    )
  }
  if ('assetVendor' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'asset_vendor',
        'in',
        filters.assetVendor,
        'long',
        'variable'
      )
    )
  }
  return qualDetails
}

export function getAssetMovementApi(
  qualifications,
  limit,
  offset,
  sortedColumn
) {
  return api
    .post(
      `asset/movement/search/byqual`,
      {
        ...(qualifications ? { qualDetails: qualifications } : {}),
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
          ...(sortedColumn ? { sort_by: sortedColumn } : {}),
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformAssetMovement),
        total: data.totalCount,
      }
    })
}

export function getMovementApi(id) {
  return api.get(`/asset/movement/${id}`).then(transformAssetMovement)
}
export function updateMovementApi({ id, ...data }) {
  return api
    .patch(
      `/asset/movement/${id}`,
      transformAssetMovementForServer({ id, ...data }),
      {
        message: __rootT('updated_successfully', {
          resource: __rootTc('asset_movement'),
        }),
      }
    )
    .then(transformAssetMovement)
}
export function getAssetsApi(id) {
  return api.get(`/asset/movement/${id}/assets`).then((data) => {
    return {
      items: (data.objectList || []).map(transformAsset),
      total: data.totalCount,
    }
  })
}
export function updateAssetsApi(movementId, assetId, data) {
  return api
    .patch(
      `/asset/movement/${movementId}/asset/${assetId}`,
      transformAssetMovementForServer(data),
      {
        message: __rootT('updated_successfully', {
          resource: __rootTc('asset'),
        }),
      }
    )
    .then(transformAssetMovement)
}
export function createAssetMovementApi(data) {
  return api
    .post(`/asset/movement`, transformAssetMovementForServer(data), {
      message: __rootT('created_successfully', {
        resource: __rootTc('asset_movement'),
      }),
    })
    .then(transformAssetMovement)
}
export function getAssetMovementInDetailsApi(
  filters,
  searchCriterias,
  limit,
  offset,
  assetType,
  deletedAssetIds
) {
  const finalQuals = []
  let finalQualDetails = null
  const qualDetails = [
    ...((searchCriterias || {}).quals || []),
    ...getQualifications(filters),
  ]
  if (qualDetails.length) {
    finalQuals.push(buildFlatQualificationStructure(qualDetails))
  }
  if (deletedAssetIds) {
    const deletedAssetIdsQual = transformBatchQualForServer(
      [
        buildRelationalQualificationStructure(
          'id',
          'in',
          deletedAssetIds,
          'long',
          'db'
        ),
      ],
      'and'
    )
    finalQuals.push(deletedAssetIdsQual)
  }
  if (finalQuals.length) {
    finalQualDetails = transformBatchQualForServer(finalQuals, 'or')
  }

  return api
    .post(
      `/asset/movement/${assetType}/search/byqual`,
      {
        qualDetails: finalQualDetails || undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map((d) => ({
          ...transformAssetMovement(d),
          statusId: d.statusId,
        })),
        total: data.totalCount,
      }
    })
}
